import { getIconBaseProps } from '../utils';

export const forex = {
  ...getIconBaseProps('forex'),
  width: '22px',
  height: '22px',
  viewBox: '0 0 22 22',
  fill: 'currentColor',
  xmlns: 'http://www.w3.org/2000/svg',
  body: (
    <>
      <path
        d='M11.8889 19.0005L3.88889 19.0005C3.39797 19.0005 3 18.6025 3 18.1116L3 6.55612C3 6.0652 3.39797 5.66724 3.88889 5.66724L8.85401 5.66724C9.08976 5.66724 9.31585 5.76089 9.48254 5.92758L12.5174 8.96243C12.6841 9.12913 12.7777 9.35522 12.7777 9.59096V18.1116C12.7777 18.6025 12.3798 19.0005 11.8889 19.0005Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.22217 5.66665L9.22217 3.88889C9.22217 3.39797 9.62014 3 10.1111 3L15.0762 3C15.3119 3 15.538 3.09365 15.7047 3.26035L18.7396 6.29519C18.9063 6.46189 18.9999 6.68798 18.9999 6.92373V15.4444C18.9999 15.9353 18.6019 16.3333 18.111 16.3333L12.7777 16.3333'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.7774 10.1117L9.22189 10.1117C8.73098 10.1117 8.33301 9.71369 8.33301 9.22278L8.33301 5.66724'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.9996 7.44442L15.4441 7.44442C14.9531 7.44442 14.5552 7.04646 14.5552 6.55554L14.5552 3'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  ),
};
